import { useState } from 'react';
import { Popup, Content } from './zone-info.styled';

export const ZoneInfo = ({ nodes, disabled }) => {
  const [showInfo, setShowInfo] = useState(false);

  const getNodes = () => {
    const values = [];
    for (let key in nodes) {
      if (nodes[key] === true) {
        values.push('У' + key);
        values.push('С' + key);
      } else {
        values.push(...nodes[key]);
      }
    }
    return values.join(',');
  };

  const other = disabled ? {} : { onMouseEnter: () => setShowInfo(true), onMouseLeave: () => setShowInfo(false) };

  return (
    <Content {...other}>
      <img src="/images/path-6.png" alt="" />
      {showInfo && (
        <Popup>
          <div />
          {getNodes()}
        </Popup>
      )}
    </Content>
  );
};
